import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Description = ({
  name,
  isChannelManager,
}: {
  name: string;
  isChannelManager: boolean;
}) => {
  const { t } = useTranslation();

  const descriptionKey = isChannelManager
    ? 'pageChannels.channelDetails.descriptionChannelManager'
    : 'pageChannels.channelDetails.descriptionChannel';

  const helpLink = isChannelManager
    ? 'https://help.hostfully.com/en/collections/1452116-compatible-channel-managers'
    : 'https://help.hostfully.com/collections/113501-channel-management';

  return (
    <div>
      <p data-testid="description">
        {t(descriptionKey, {
          name,
        })}
      </p>
      <p data-testid="help-link">
        <Trans
          i18nKey="pageChannels.channelDetails.help"
          components={{
            1: <Link to={helpLink} target="_blank" rel="noreferrer" />,
          }}
        />
      </p>
    </div>
  );
};

export default Description;
